/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Index_Announcement_ButtonInputs */

const en_index_announcement_button = /** @type {(inputs: Index_Announcement_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a demo`)
};

/**
* | output |
* | --- |
* | "Book a demo" |
*
* @param {Index_Announcement_ButtonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const index_announcement_button = /** @type {((inputs?: Index_Announcement_ButtonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Index_Announcement_ButtonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_index_announcement_button(inputs)
});